import styled from "styled-components";
import { Flex, Text } from "rebass/styled-components";
import { HiViewGrid } from "react-icons/hi";

import { StudioIcon } from "MVVM/Views/Studio/Components/StudioIcons";
import { EStudioIconType } from "MVVM/Views/Studio/@types";

interface IGameFilterProps {
  active: string | null;
  onChange: (game: string | null) => void;
}

const GAMES = [
  { key: "CS2", label: "CS2", icon: EStudioIconType.CS2 },
  { key: "FORTNITE", label: "Fortnite", icon: EStudioIconType.Fortnite },
  { key: "LOL", label: "League", icon: EStudioIconType.LoL },
  { key: "DOTA2", label: "Dota 2", icon: EStudioIconType.Dota2 },
  { key: "OW2", label: "OW2", icon: EStudioIconType.OW2 },
];

export const GameFilter = ({ active, onChange }: IGameFilterProps) => {
  return (
    <Rail>
      <Chip $isActive={active === null} onClick={() => onChange(null)}>
        <DesktopIcon>
          <HiViewGrid size={16} />
        </DesktopIcon>
        <MobileIcon>
          <HiViewGrid size={22} />
        </MobileIcon>
        <ChipLabel>All</ChipLabel>
      </Chip>
      {GAMES.map((g) => (
        <Chip
          key={g.key}
          $isActive={active === g.key}
          onClick={() => onChange(active === g.key ? null : g.key)}
        >
          <DesktopIcon>
            <StudioIcon size={16} type={g.icon} />
          </DesktopIcon>
          <MobileIcon>
            <StudioIcon size={22} type={g.icon} />
          </MobileIcon>
          <ChipLabel>{g.label}</ChipLabel>
        </Chip>
      ))}
    </Rail>
  );
};

const Rail = styled(Flex)`
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 4px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const DesktopIcon = styled.span`
  align-items: center;
  display: flex;
  justify-content: center;
  line-height: 0;

  @media (max-width: 715px) {
    display: none;
  }
`;

const MobileIcon = styled.span`
  align-items: center;
  display: none;
  justify-content: center;
  line-height: 0;

  @media (max-width: 715px) {
    display: flex;
  }
`;

const Chip = styled.button<{ $isActive: boolean }>`
  align-items: center;
  background: ${({ $isActive, theme }) =>
    $isActive ? theme.colors.envyAlpha10 : theme.colors.navy300};
  border: 1px solid
    ${({ $isActive, theme }) =>
      $isActive ? theme.colors.envy : theme.colors.navy50};
  border-radius: 999px;
  color: ${({ $isActive, theme }) =>
    $isActive ? theme.colors.envy : theme.colors.chalk};
  cursor: pointer;
  display: flex;
  font-family: Barlow, sans-serif;
  font-size: 13px;
  font-weight: 600;
  gap: 6px;
  height: 34px;
  justify-content: center;
  padding: 0 14px;
  transition: all 0.15s ease;
  white-space: nowrap;

  &:hover {
    border-color: ${({ $isActive, theme }) =>
      $isActive ? theme.colors.envy : theme.colors.navy};
  }

  svg {
    color: ${({ $isActive, theme }) =>
      $isActive ? theme.colors.envy : theme.colors.shade400};
    flex-shrink: 0;
  }

  @media (max-width: 715px) {
    height: 42px;
    min-width: 42px;
    padding: 0;
  }
`;

const ChipLabel = styled(Text)`
  font-size: 13px;

  @media (max-width: 715px) {
    display: none;
  }
`;
